export const NAMESPACE = 'application';

export const INITIALIZED = `${NAMESPACE}/INITIALIZED`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const UPDATE_LAST_USED_DC = `${NAMESPACE}/UPDATE_LAST_USED_DC`;
export const LAST_USED_DC = 'lastUsedDataCenter';
